import { render, staticRenderFns } from "./GroupStandards.vue?vue&type=template&id=acbbca58"
import script from "./GroupStandards.vue?vue&type=script&lang=js"
export * from "./GroupStandards.vue?vue&type=script&lang=js"
import style0 from "./GroupStandards.vue?vue&type=style&index=0&id=acbbca58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports